export default __webpack_public_path__ + "static/media/Martijn01.f3b0fa2c.jpg";